import IconSvg from 'core/_legacy/icons/IconSvg'

const DinersClubLogo = () => (
  <IconSvg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="#555"
  >
    <g id="surface1">
      <path
        d="M 45 35 C 45 37.199219 43.199219 39 41 39 L 7 39 C 4.800781 39 3 37.199219 3 35 L 3 13 C 3 10.800781 4.800781 9 7 9 L 41 9 C 43.199219 9 45 10.800781 45 13 Z"
        fill="#cfd8dc"
      />
      <path
        d="M 29 16 L 19 16 C 14.601563 16 11 19.601563 11 24 C 11 28.398438 14.601563 32 19 32 L 29 32 C 33.398438 32 37 28.398438 37 24 C 37 19.601563 33.398438 16 29 16 Z"
        fill="#1565c0"
      />
      <path
        d="M 19 18 C 15.699219 18 13 20.699219 13 24 C 13 27.300781 15.699219 30 19 30 C 22.300781 30 25 27.300781 25 24 C 25 20.699219 22.300781 18 19 18 Z M 15 24 C 15 22.101563 16.300781 20.601563 18 20.101563 L 18 27.800781 C 16.300781 27.398438 15 25.898438 15 24 Z M 20 27.898438 L 20 20.199219 C 21.699219 20.601563 23 22.199219 23 24.101563 C 23 25.898438 21.699219 27.398438 20 27.898438 Z"
        fill="#fff"
      />
    </g>
  </IconSvg>
)

export default DinersClubLogo
